/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Composables
import configs from "@/configs";
import i18n from "@/plugins/vue-i18n";
import { createVuetify } from 'vuetify';

export default createVuetify({
  defaults: {
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      clearIcon: 'mdi-close',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable',
      clearIcon: 'mdi-close',
      noDataText: i18n.global.t('$vuetify.dataIterator.noResultsText'),
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      clearIcon: 'mdi-close',
    },
    VBtn: {
      variant: 'flat',
      rounded: 'lg',
    },
    VCard: {
      rounded: 'lg',
      elevation: 0,
      border: true,
    },
    VChip: {
      rounded: 'md',
    },
  },
  theme: {
    themes: {
      light: configs.theme.light,
    },
    variations: {
      colors: ["primary"],
      lighten: 5,
      darken: 5
    },
  },
})
